@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.dashboard

import org.example.project.manager.NodeScope

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.example.project.service.LoginService
import org.example.project.screens_driver.DriverFlowState
import org.example.project.utils.All
import org.example.project.utils.LocalizationManager

@Composable
fun DriverDashboardScreen(
    art: String = NodeScope.NET,
    screens: List<All>,
    onLogout: () -> Unit,
    onOpenProfile: (() -> Unit)? = null
) {
    var user by remember { mutableStateOf(LoginService.getUser()) }
    var selectedKey by DriverFlowState.selectedScreenKey
    var backStack by remember { mutableStateOf(listOf<String>()) }
    var isPaused by remember { mutableStateOf(false) }
    var openScreens by remember { mutableStateOf(setOf<String>()) }
    var showRecents by remember { mutableStateOf(false) }
    var showPasswordOverlay by remember { mutableStateOf(false) }

    MobileFocusCloseEffect {
        selectedKey = "DASHBOARD"
        backStack = emptyList()
    }

    if (user == null) return
    LaunchedEffect(user?.sprache) {
        LocalizationManager.load(user?.sprache.orEmpty().ifBlank { "de" })
    }

    fun logoutCurrentUser() {
        LoginService.logout()
        onLogout()
    }

    DriverDashboardLayout(
        screens = screens,
        selectedKey = selectedKey,
        onSelect = { key ->
            if (key != selectedKey) backStack = backStack + selectedKey
            selectedKey = key
            openScreens += key
        },
        onBack = {
            val handled = MobileDashboardBackHandler.handler.value?.invoke() == true ||
                DriverFlowState.mobileBackHandler.value?.invoke() == true
            if (!handled) {
                val previous = backStack.lastOrNull()
                if (previous != null) {
                    selectedKey = previous
                    backStack = backStack.dropLast(1)
                } else {
                    selectedKey = "DASHBOARD"
                }
            }
        },
        isPaused = isPaused,
        setPaused = { },
        onLogout = { logoutCurrentUser() },
        onHomeTap = {
            selectedKey = "DASHBOARD"
            backStack = emptyList()
        },
        onHomeLongPress = {
            if (openScreens.isNotEmpty()) showRecents = true
        },
        onOpenProfile = {
            showPasswordOverlay = true
            onOpenProfile?.invoke()
        },
    )

    if (showRecents) {
        DriverRecentsSwipeLayer(
            openKeys = openScreens.toList(),
            allScreens = screens,
            onDismiss = { key ->
                openScreens -= key
                if (selectedKey == key) selectedKey = "DASHBOARD"
                if (openScreens.isEmpty()) showRecents = false
            },
            onSelect = { key ->
                selectedKey = key
                showRecents = false
            },
            onClose = { showRecents = false }
        )
    }

    if (showPasswordOverlay) {
        PasswordChangeOverlay(
            art = "driver",
            onClose = { showPasswordOverlay = false },
            onLogout = { logoutCurrentUser() }
        )
    }
    ServiceDocumentViewerOverlayLayer()
}
